import p128 from "./128.gif";
import p194 from "./194.gif";
import p211 from "./211.gif";
import p906 from "./906.gif";
import p907 from "./907.gif";
import p908 from "./908.gif";
import p909 from "./909.gif";
import p910 from "./910.gif";
import p911 from "./911.gif";
import p912 from "./912.gif";
import p913 from "./913.gif";
import p914 from "./914.gif";
import p915 from "./915.gif";
import p916 from "./916.gif";
import p917 from "./917.gif";
import p918 from "./918.gif";
import p919 from "./919.gif";
import p920 from "./920.gif";
import p921 from "./921.gif";
import p922 from "./922.gif";
import p923 from "./923.gif";
import p924 from "./924.gif";
import p925 from "./925.gif";
import p926 from "./926.gif";
import p927 from "./927.gif";
import p928 from "./928.gif";
import p929 from "./929.gif";
import p930 from "./930.gif";
import p931 from "./931.gif";
import p932 from "./932.gif";
import p933 from "./933.gif";
import p934 from "./934.gif";
import p935 from "./935.gif";
import p936 from "./936.gif";
import p937 from "./937.gif";
import p938 from "./938.gif";
import p939 from "./939.gif";
import p940 from "./940.gif";
import p941 from "./941.gif";
import p942 from "./942.gif";
import p943 from "./943.gif";
import p944 from "./944.gif";
import p945 from "./945.gif";
import p946 from "./946.gif";
import p947 from "./947.gif";
import p948 from "./948.gif";
import p949 from "./949.gif";
import p950 from "./950.gif";
import p951 from "./951.gif";
import p952 from "./952.gif";
import p953 from "./953.gif";
import p954 from "./954.gif";
import p955 from "./955.gif";
import p956 from "./956.gif";
import p957 from "./957.gif";
import p958 from "./958.gif";
import p959 from "./959.gif";
import p960 from "./960.gif";
import p961 from "./961.gif";
import p962 from "./962.gif";
import p963 from "./963.gif";
import p964 from "./964.gif";
import p965 from "./965.gif";
import p966 from "./966.gif";
import p967 from "./967.gif";
import p968 from "./968.gif";
import p969 from "./969.gif";
import p970 from "./970.gif";
import p971 from "./971.gif";
import p972 from "./972.gif";
import p973 from "./973.gif";
import p974 from "./974.gif";
import p975 from "./975.gif";
import p976 from "./976.gif";
import p977 from "./977.gif";
import p978 from "./978.gif";
import p979 from "./979.gif";
import p980 from "./980.gif";
import p981 from "./981.gif";
import p982 from "./982.gif";
import p983 from "./983.gif";
import p984 from "./984.gif";
import p985 from "./985.gif";
import p986 from "./986.gif";
import p987 from "./987.gif";
import p988 from "./988.gif";
import p989 from "./989.gif";
import p990 from "./990.gif";
import p991 from "./991.gif";
import p992 from "./992.gif";
import p993 from "./993.gif";
import p994 from "./994.gif";
import p995 from "./995.gif";
import p996 from "./996.gif";
import p997 from "./997.gif";
import p998 from "./998.gif";
import p999 from "./999.gif";
import p1000 from "./1000.gif";
import p1001 from "./1001.gif";
import p1002 from "./1002.gif";
import p1003 from "./1003.gif";
import p1004 from "./1004.gif";
import p1005 from "./1005.gif";
import p1006 from "./1006.gif";
import p1007 from "./1007.gif";
import p1008 from "./1008.gif";
import p1009 from "./1009.gif";
import p1010 from "./1010.gif";

const gifs = {
    p128: p128,
    p194: p194,
    p211: p211,
    p906: p906,
    p907: p907,
    p908: p908,
    p909: p909,
    p910: p910,
    p911: p911,
    p912: p912,
    p913: p913,
    p914: p914,
    p915: p915,
    p916: p916,
    p917: p917,
    p918: p918,
    p919: p919,
    p920: p920,
    p921: p921,
    p922: p922,
    p923: p923,
    p924: p924,
    p925: p925,
    p926: p926,
    p927: p927,
    p928: p928,
    p929: p929,
    p930: p930,
    p931: p931,
    p932: p932,
    p933: p933,
    p934: p934,
    p935: p935,
    p936: p936,
    p937: p937,
    p938: p938,
    p939: p939,
    p940: p940,
    p941: p941,
    p942: p942,
    p943: p943,
    p944: p944,
    p945: p945,
    p946: p946,
    p947: p947,
    p948: p948,
    p949: p949,
    p950: p950,
    p951: p951,
    p952: p952,
    p953: p953,
    p954: p954,
    p955: p955,
    p956: p956,
    p957: p957,
    p958: p958,
    p959: p959,
    p960: p960,
    p961: p961,
    p962: p962,
    p963: p963,
    p964: p964,
    p965: p965,
    p966: p966,
    p967: p967,
    p968: p968,
    p969: p969,
    p970: p970,
    p971: p971,
    p972: p972,
    p973: p973,
    p974: p974,
    p975: p975,
    p976: p976,
    p977: p977,
    p978: p978,
    p979: p979,
    p980: p980,
    p981: p981,
    p982: p982,
    p983: p983,
    p984: p984,
    p985: p985,
    p986: p986,
    p987: p987,
    p988: p988,
    p989: p989,
    p990: p990,
    p991: p991,
    p992: p992,
    p993: p993,
    p994: p994,
    p995: p995,
    p996: p996,
    p997: p997,
    p998: p998,
    p999: p999,
    p1000: p1000,
    p1001: p1001,
    p1002: p1002,
    p1003: p1003,
    p1004: p1004,
    p1005: p1005,
    p1006: p1006,
    p1007: p1007,
    p1008: p1008,
    p1009: p1009,
    p1010: p1010
};

export default gifs;
